import { push } from "connected-react-router";
import React, {useState} from "react";
import { useDispatch } from "react-redux";
import { ROUTE_PATH, APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE, APPLICATION_MODE_NEW, APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE } from "../../../app/constants";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import { replaceUrlParams } from '../../../app/utils'
import {
  Header,
  NavigationLinkButton
} from "../../../components/RegularComponents";
import { ERROR_STRING } from "../../../app/errors";
import TopNavigationBar from "../../TopNavigationBar";
// import { setMortgageProperty } from "../../redux/slice/primaryAgencyApplicationSlice";

const applicationType = APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE;
const applicationMode = APPLICATION_MODE_NEW;

export const AssociateBrokerNotCompletedCourse= (props) => {
  const dispatch = useDispatch();
  const [applicationSaveError, setApplicationSaveError] = useState(false);

  return (
    <div className="container">
      <TopNavigationBar {...props} hideSaveAndExit applicationType={applicationType} applicationMode={applicationMode} />
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-10">
          <Header
            style={{ paddingBottom: "30px" }}
            id="associate-broker-continue-application-header"
            header="The applicant must complete the Nova Scotia Associate Mortgage Broker course and provide proof of completion before they can apply for a licence"
          />
        </div>
      </div>

      <div className="row">
        <div className="col-lg-4">
          <NavigationLinkButton
            id={"cancel-quick-link"}
            text={"Back to home page"}
            onClick={() => {

                let nextUrl = replaceUrlParams(ROUTE_PATH.WELCOME, APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, applicationMode)

                // On to the next item
                dispatch(
                    saveBusinessLicenceApplicationData(
                      applicationType,
                      applicationMode
                    )
                  )
                .then((data) => {
                    dispatch(
                        push(nextUrl)
                    );
                })
                .catch((err) => {
                    setApplicationSaveError(true);
                });
            
            }}
          />
            {applicationSaveError && (
              <div className="ns-error-message help-block topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};
